import { createSelector } from 'reselect';
import moment from 'moment';
import CommentsConstants from 'Shared/constants/Comments.constants';

// TODO (josh) : this key should come from a constant
const getCommentsItems = state => state.commentsItems;

function createParameterSelector(selector) {
  return (_, params) => selector(params);
}

const getGoalSlugParam = createParameterSelector(params => params.goalSlug);

const getAllComments = createSelector([getCommentsItems], comments => {
  return comments.get(CommentsConstants.State.COMMENTS_BY_SLUG);
});

export const getCommentsByGoalSlug = createSelector([getAllComments, getGoalSlugParam], (comments, slug) =>
  comments
    .filter(comment => comment.get('goalSlug') === slug)
    .sortBy(comment => moment(comment.get('createdAt')).unix())
);
